<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre9 sgc-15 sigilNotInTOC" id="heading_id_2">CONTENTS</h1>
<p class="calibre5 ind20"><a href="#/Text/Chapter01">1.    At Edgewood</a></p>
<p class="calibre1 ind20"><a href="#/Text/Chapter02">2.    At the Library</a></p>
<p class="calibre1 ind20"><a href="#/Text/Chapter03">3.    At the Wakefield</a></p>
<p class="calibre1 ind20"><span href="#/Text/Chapter04" title="Link target outside of Sample">4.    At the Carringtons’</span></p>
<p class="calibre1 ind20"><span href="#/Text/Chapter05" title="Link target outside of Sample">5.    Psychological</span></p>
<p class="calibre1 ind20"><span href="#/Text/Chapter06" title="Link target outside of Sample">6.    The Facts</span></p>
<p class="calibre1 ind20"><span href="#/Text/Chapter07" title="Link target outside of Sample">7.    Descendants</span></p>
<p class="calibre1 ind20"><span href="#/Text/Chapter08" title="Link target outside of Sample">8.    Case Histories</span></p>
<p class="calibre1 ind20"><span href="#/Text/Chapter09" title="Link target outside of Sample">9.    Inside Stuff</span></p>
<p class="calibre1"><span href="#/Text/Chapter10" title="Link target outside of Sample">10.    Monsters</span></p>
<p class="calibre1"><span href="#/Text/Chapter11" title="Link target outside of Sample">11.    Criminology</span></p>
<p class="calibre1"><span href="#/Text/Chapter12" title="Link target outside of Sample">12.    Eliminations</span></p>
<p class="calibre1"><span href="#/Text/Chapter13" title="Link target outside of Sample">13.    Triumph of Vines</span></p>
<p class="calibre1"><span href="#/Text/Chapter14" title="Link target outside of Sample">14.    Clearance</span></p>
<p class="calibre1"><span href="#/Text/Chapter15" title="Link target outside of Sample">15.    The Trellis</span></p>
<p class="calibre1"><span href="#/Text/Chapter16" title="Link target outside of Sample">16.    Obsession</span></p>
<p class="calibre1"><span href="#/Text/Chapter17" title="Link target outside of Sample">17.    Evidence</span></p>
<p class="calibre1"><span href="#/Text/Chapter18" title="Link target outside of Sample">18.    Love Letter</span></p>
<p class="calibre1"><span href="#/Text/Chapter19" title="Link target outside of Sample">19.    Night Walk</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?93dcb5a4